import { useLocation } from 'react-router-dom';

export const useMockStep = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('mockStep'); // returns string or null
};